import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { reloadSystemCache } from 'services/common/apiCommon';


export function useReloadSystemCache() {
  const mutation = useMutation({
    mutationFn: () => reloadSystemCache(),
    onSuccess: (data) => {
      if (data?.status === 200) {
        toast.success(data?.data?.message || "System cache updated successfully.")
      }
    }
  });

  return mutation;
}